export function phoneValidate(phone: string) {
  return phone.replace(/[^+\d]/g, '')
}
